/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Env } from './env-vars'

export const SHARED_SDK_OPTIONS = {
  clientId: Env.CUSTOMER_PORTAL_APP_CLIENT_ID,
  namespace: '',
  redirectURI: Env.CUSTOMER_PORTAL_APP_REDIRECT_URI
}
